import { render } from "./AccaShare.vue?vue&type=template&id=0cc0698e&scoped=true"
import script from "./AccaShare.vue?vue&type=script&lang=js"
export * from "./AccaShare.vue?vue&type=script&lang=js"

import "./AccaShare.vue?vue&type=style&index=0&id=0cc0698e&scoped=true&lang=css"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc0698e"]])

export default __exports__